<template>
  <div>
    <VListItem
      v-for="(instruction, i) in specialInstructions"
      :key="`instruction-${i}`"
      dense
      class="px-0 py-0 mb-2"
      v-bind="$attrs"
    >
      <VListItemAction class="my-0 mr-1 align-self-baseline">
        <VCheckbox
          :input-value="instruction.archived || instruction.complete"
          readonly
          :ripple="false"
          dense
        />
      </VListItemAction>
      <VListItemContent class="pa-0">
        <div>
          <div
            class="float-right text-caption grey--text"
            :title="formatDateVerbose(instruction.createdDate)"
            style="margin-top: 1px"
            v-text="
              formatDateDistanceToNowIfRecentShort(instruction.createdDate)
            "
          />
          <h5
            class="text-subtitle-2"
            v-text="
              instruction.name +
              (instruction.type ? ` (${instruction.type})` : '')
            "
          />
        </div>
        <div
          v-if="instruction.description"
          class="caption"
          v-text="instruction.description"
        />
      </VListItemContent>
    </VListItem>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import {
  formatDateDistanceToNowIfRecentShort,
  formatDateVerbose
} from '@/components/mixins/dateFormatters'
import {
  CustomerSpecialInstruction,
  OrderSpecialInstruction,
  ProofSpecialInstruction
} from '@/generated'

export default defineComponent({
  props: {
    specialInstructions: {
      type: Array as PropType<
        | CustomerSpecialInstruction[]
        | ProofSpecialInstruction[]
        | OrderSpecialInstruction[]
      >,
      required: true
    }
  },
  setup() {
    return {
      formatDateVerbose,
      formatDateDistanceToNowIfRecentShort
    }
  }
})
</script>

<style scoped lang="scss">
::v-deep .v-list-item--dense {
  // Decrease height to ensure display looks right when there's only one line
  min-height: 24px !important;
  // Prevent tooltips from being too skinny (leading to unnecessary wrapping) with shorter content
  // TODO: Find a more flexible way of doing this, so short tooltips aren't forced to be unnecessarily wide
  min-width: 240px;
}
</style>
